import Vue from 'vue'

export const conference = {
    namespaced: true,
    state: {
        participantId: '',
        userName: '',
        userIdentificationType: '',
        userIdentification: '',
        roomId: '',
        conferenceName: '',
        mediaStreamConstraints: {},
        users: [],
        participants: [],

        recording: false,
        recorder: null,
        shareStream: null,
        stream: null,

        openedSettings: false,
        openedHistorical: false,
        openedSidebar: true,
    },
    actions: {
        setConference({ commit }, { userName, userIdentificationType, userIdentification, mediaStreamConstraints }) {
            commit('setConference', { userName, userIdentificationType, userIdentification, mediaStreamConstraints })
        },
        setConferenceId({ commit }, { roomId }) {
            commit('setConferenceId', { roomId });
        },
        setConferenceName({ commit }, { name }) {
            commit('setConferenceName', { name });
        },
        setMediaStreamConstraints({ commit }, { mediaStreamConstraints }) {
            commit('setMediaStreamConstraints', { mediaStreamConstraints });
        },
        updateUsers({ commit }, { users }) {
            commit('updateUsers', { users });
        },
        setParticipantId({ commit }, { id }) {
            commit('setParticipantId', { id });
        },
        setRecording({ commit }) {
            commit('setRecording');
        },
        setRecorder({ commit }, recorder ) {
            commit('setRecorder', recorder );
        },
        setShareStream({ commit }, shareStream ) {
            commit('setShareStream', shareStream );
        },
        setStream({ commit }, stream ) {
            commit('setStream', stream );
        },
        toggleSettings({ commit }) {
            commit('toggleSettings');
        },
        toggleHistorical({ commit }) {
            commit('toggleHistorical');
        },
        toggleSidebar({ commit }) {
            commit('toggleSidebar');
        },
        setParticipants({ commit }, participants) {
            commit('setParticipants', participants);
        }
    },
    mutations: {
        setConference(state, { userName, userIdentificationType, userIdentification, mediaStreamConstraints }) {
            Vue.set(state, 'userName', userName);
            Vue.set(state, 'userIdentificationType', userIdentificationType);
            Vue.set(state, 'userIdentification', userIdentification);
            Vue.set(state, 'mediaStreamConstraints', mediaStreamConstraints);
        },
        setConferenceId(state, { roomId }) {
            Vue.set(state, 'roomId', roomId);
        },
        setConferenceName(state, { name }) {
            Vue.set(state, 'conferenceName', name);
        },
        setMediaStreamConstraints(state, { mediaStreamConstraints }) {
            Vue.set(state, 'mediaStreamConstraints', mediaStreamConstraints);
        },
        updateUsers(state, { users }) {
            Vue.set(state, 'users', users);
        },
        setParticipantId(state, { id }) {
            Vue.set(state, 'participantId', id);
        },
        setRecording(state) {
            Vue.set(state, 'recording', !state.recording);
        },
        setRecorder(state, recorder) {
            Vue.set(state, 'recorder', recorder);
        },
        setShareStream(state, shareStream) {
            Vue.set(state, 'shareStream', shareStream);
        },
        setStream(state, stream) {
            Vue.set(state, 'stream', stream);
        },
        toggleSettings(state) {
            Vue.set(state, 'openedSettings', !state.openedSettings)
        },
        toggleHistorical(state) {
            Vue.set(state, 'openedHistorical', !state.openedHistorical);
        },
        toggleSidebar(state) {
            Vue.set(state, 'openedSidebar', !state.openedSidebar);
        },
        setParticipants(state, participants) {
            Vue.set(state, 'participants', participants);
        }
    },
    getters: {
        getParticipantId: state => state.participantId,
        getUserName: state => state.userName,
        getMediaStreamConstraints: state => state.mediaStreamConstraints,
        getUserIdentificationType: state => state.userIdentificationType,
        getUserIdentification: state => state.userIdentification,
        getConferenceName: state => state.conferenceName,
        getConferenceId: state => state.roomId,
        getUsers: state => state.users,
        getOtherUsers: state => {
            let users = state.users.filter(u => u.id !== state.participantId);
            return users;
        },
        getParticipants: state => state.participants,
        isOpenedSettings: state => state.openedSettings,
        isOpenedHistorical: state => state.openedHistorical,
        isOpenedSidebar: state => state.openedSidebar,
        isRecording: state => state.recording,
        getRecorder: state => state.recorder,
        getShareStream: state => state.shareStream,
        getStream: state => state.stream
    }
}